export default __webpack_public_path__ + "static/media/specialties.693cc0d6.png";